import { createAsyncThunk } from '@reduxjs/toolkit'
import Title from './title-model'
import { delete_title, load_titles, store_title } from './title-service'

export const LoadTitlesAsync = createAsyncThunk<any, any>(
  'composer/load/title',
  async (params: { uid: string }) => {
    return await load_titles(params)
  },
)

export const CreateTitleAsync = createAsyncThunk<any, any>(
  'composer/create/title',
  async (params: Title) => {
    return await store_title(params)
  },
)

export const DeleteTitleAsync = createAsyncThunk<any, any>(
  'composer/delete/title',
  async (params) => {
    return await delete_title(params)
  },
)
